<template>
  <div class="card pb-0 mb-0 rounded-0">
    <div class="card-header p-0 d-flex justify-content-between" :id="`heading${ dataInfo.id }`">
      <button
        class="btn btn-sm btn-link"
        data-toggle="collapse"
        aria-expanded="true"
        :data-target="`#collapse${ dataInfo.id }`"
        :aria-controls="`#collapse${ dataInfo.id }`"
        @click="loadModuleData"
      >
        {{ dataInfo.name }}
      </button>

      <button class="btn btn-sm" @click="addClass">
        <i class="fas fa-plus-circle"></i>
      </button>
    </div>

    <div :id="`collapse${ dataInfo.id }`" class="collapse" :aria-labelledby="`heading${ dataInfo.id }`" data-parent="#accordionModules">
      <table class="table table-sm table-bordered mb-0">
        <tr v-for="itemClass,i in dataInfo.classes" :key="i" @click="loadClassData( itemClass )">
          <td class="text-left pl-2"><small>{{ itemClass.name }}</small></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      dataInfo: {}
    }
  },
  methods: {
    loadModuleData: function () {
      this.$emit('loadData', this.dataInfo)
    },

    loadClassData: function ( data ) {
      this.$emit('loadData', data)
    },

    addClass: function () {
      let id = 1
      if ( this.dataInfo.classes.length > 0 ) {
        id = this.dataInfo.classes[ this.dataInfo.classes.length - 1 ].id + 1
      }

      this.dataInfo.classes = [
        ...this.dataInfo.classes, {
        "id": this.dataInfo.classes.length + 1,
        "module_id": this.dataInfo.id,
        "name": "Nova Aula",
        "description": "",
        "module": false,
        "media": "",
        "cover": "",
        "video": "",
      }]
    }
  },
  beforeMount() {
    this.dataInfo = Object.assign({}, this.item)
  },
}
</script>

<style>

</style>
